module.exports = __webpack_public_path__ + "static/media/home-city.1230403f.svg";